import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type AccessView = 'login' | 'signup' | 'recover';

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.access-page {
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.56), rgba(255, 255, 255, 0) 46%), var(--ops-bg);
  color: var(--ops-text);
  padding: 40px 20px;
}

.access-shell {
  display: grid;
  width: min(920px, 100%);
  grid-template-columns: minmax(0, 1fr) 430px;
  align-items: stretch;
  gap: 18px;
}

.access-context {
  display: flex;
  min-height: 520px;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: var(--ops-radius);
  background: #101615;
  color: #f8fcfa;
  box-shadow: var(--ops-shadow-strong);
  padding: 28px;
}

.access-card {
  min-height: 520px;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius);
  background: var(--ops-surface);
  box-shadow: var(--ops-shadow);
  padding: 26px;
}

.access-brand {
  display: flex;
  align-items: center;
  gap: 14px;
}

.access-brand-mark {
  display: flex;
  width: 46px;
  height: 46px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: var(--ops-radius);
  background: #f8fcfa;
  color: var(--ops-primary-dark);
}

.access-brand-mark svg {
  width: 28px;
  height: 28px;
}

.access-kicker {
  color: rgba(216, 233, 222, 0.68);
  font-size: 11px;
  font-weight: 900;
}

.access-brand h1 {
  margin-top: 6px;
  color: #ffffff;
  font-size: 28px;
  font-weight: 900;
  line-height: 1.18;
}

.access-status {
  display: grid;
  gap: 8px;
  margin-top: auto;
}

.access-status-item {
  display: flex;
  min-height: 38px;
  align-items: center;
  gap: 9px;
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: var(--ops-radius-sm);
  background: rgba(255, 255, 255, 0.045);
  color: rgba(238, 248, 241, 0.88);
  font-size: 12px;
  font-weight: 900;
  padding: 0 11px;
}

.access-status-dot {
  width: 7px;
  height: 7px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: var(--ops-success);
}

.access-status-dot--blue {
  background: var(--ops-info);
}

.access-status-dot--amber {
  background: var(--ops-warning);
}

.access-support {
  margin-top: 34px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(216, 233, 222, 0.72);
  font-size: 12px;
  font-weight: 750;
  line-height: 1.5;
  padding-top: 18px;
}

.access-support-contact {
  margin-top: 8px;
  color: #ffffff;
  font-weight: 900;
}

.access-card-header {
  margin-bottom: 18px;
}

.access-mobile-mark {
  display: flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  border-radius: var(--ops-radius);
  background: var(--ops-primary);
  color: #ffffff;
  box-shadow: 0 10px 22px rgba(17, 24, 39, 0.14);
}

.access-mobile-mark svg {
  width: 28px;
  height: 28px;
}

.access-eyebrow {
  margin: 0;
  color: var(--ops-muted);
  font-size: var(--ops-type-body-sm);
  font-weight: 700;
  letter-spacing: 0;
}

.access-card h2 {
  margin: 6px 0 0;
  color: var(--ops-heading);
  font-size: 25px;
  font-weight: 900;
  line-height: 1.22;
}

.access-tabs {
  display: grid;
  min-height: 40px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 4px;
  margin-bottom: 20px;
  border-radius: var(--ops-radius-sm);
  background: var(--ops-surface-strong);
  padding: 4px;
}

.access-tab {
  min-width: 0;
  border: 0;
  border-radius: var(--ops-radius-xs);
  background: transparent;
  color: var(--ops-muted);
  font-size: var(--ops-type-body);
  font-weight: 750;
}

.access-tab.is-active {
  background: var(--ops-surface);
  color: var(--ops-heading);
  box-shadow: 0 1px 3px rgba(17, 24, 39, 0.08);
}

.access-form {
  display: grid;
  gap: 14px;
}

.access-field-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.access-field {
  display: grid;
  gap: 7px;
}

.access-field label,
.access-label-row label {
  color: var(--ops-muted-strong);
  font-size: var(--ops-type-body);
  font-weight: 750;
}

.access-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.access-field input[type=text],
.access-field input[type=email],
.access-field input[type=tel],
.access-field input[type=password] {
  width: 100%;
  height: 42px;
  border: 1px solid var(--ops-border-strong);
  border-radius: var(--ops-radius-sm);
  outline: 0;
  background: var(--ops-surface);
  color: var(--ops-heading);
  font-size: 14px;
  padding: 0 12px;
}

.access-field input::placeholder {
  color: #9aa3a0;
}

.access-field input:focus {
  border-color: var(--ops-primary);
  box-shadow: 0 0 0 2px rgba(37, 44, 40, 0.14);
}

.access-password-wrap {
  position: relative;
}

.access-password-wrap input {
  padding-right: 46px !important;
}

.access-icon-button {
  display: flex;
  position: absolute;
  top: 50%;
  right: 6px;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);
  border: 0;
  border-radius: var(--ops-radius-xs);
  background: transparent;
  color: var(--ops-muted);
}

.access-icon-button:hover,
.access-icon-button:focus {
  outline: 0;
  background: var(--ops-surface-strong);
  color: var(--ops-heading);
}

.access-icon-button svg {
  width: 19px;
  height: 19px;
}

.access-text-action,
.access-inline-actions button,
.access-secondary {
  border: 0;
  background: transparent;
  color: var(--ops-primary);
  font-size: var(--ops-type-body);
  font-weight: 750;
  white-space: nowrap;
}

.access-checkbox {
  display: flex;
  min-height: 24px;
  align-items: center;
  gap: 8px;
  color: var(--ops-muted);
  font-size: var(--ops-type-body);
  font-weight: 600;
}

.access-checkbox input {
  width: 16px;
  height: 16px;
  accent-color: var(--ops-success);
}

.access-checkbox span {
  white-space: nowrap;
}

.access-submit,
.access-secondary {
  width: 100%;
  min-height: 42px;
  border-radius: var(--ops-radius-sm);
}

.access-submit {
  border: 1px solid var(--ops-primary);
  background: var(--ops-primary);
  color: #ffffff;
  font-size: 14px;
  font-weight: 800;
  box-shadow: none;
}

.access-submit:hover,
.access-submit:focus {
  outline: 0;
  border-color: var(--ops-primary-dark);
  background: var(--ops-primary-dark);
}

.access-secondary {
  border: 1px solid var(--ops-border);
  background: var(--ops-surface-muted);
}

.access-inline-actions {
  display: flex;
  min-height: 28px;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.access-inline-actions span {
  width: 1px;
  height: 12px;
  background: var(--ops-border);
}

.access-notice {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  border: 1px solid var(--ops-info-border);
  border-radius: var(--ops-radius-sm);
  background: var(--ops-info-soft);
  color: var(--ops-info);
  font-size: var(--ops-type-body);
  line-height: 1.5;
  padding: 12px;
}

.access-notice svg {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  margin-top: 1px;
}

.access-footer {
  margin: 18px 0 0;
  color: var(--ops-muted);
  font-size: var(--ops-type-body-sm);
  text-align: center;
}

@media (max-width: 860px) {
  .access-shell {
    display: block;
    width: min(430px, 100%);
  }
  .access-context {
    display: none;
  }
}
@media (max-width: 520px) {
  .access-page {
    background: var(--ops-surface);
    padding: 0;
  }
  .access-card {
    min-height: 100vh;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    padding: 26px 20px;
  }
  .access-tabs {
    grid-template-columns: 1fr;
  }
  .access-tab {
    min-height: 36px;
  }
  .access-field-grid {
    grid-template-columns: 1fr;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef    )         public ref: ChangeDetectorRef    ) { }

    public view: AccessView = 'login';
    public busy: boolean = false;
    public rememberEmail: boolean = true;
    public showPassword: boolean = false;
    public showSignupPassword: boolean = false;

    public titleMap: any = {
        login: '로그인',
        signup: '회원가입',
        recover: '비밀번호 찾기'
    };

    public get currentYear() {
        return new Date().getFullYear();
    }

    public data: any = {
        email: '',
        password: ''
    };

    public signupData: any = {
        name: '',
        email: '',
        mobile: '',
        password: '',
        passwordConfirm: '',
        agreement: false
    };

    public recoverData: any = {
        email: '',
        name: ''
    };

    public async ngOnInit(): Promise<void> {
        await this.service.init(this);
        let check = await this.service.auth.check();
        if (check) {
            location.href = '/dashboard';
            return;
        }

        let savedEmail = this.getSavedEmail();
        if (savedEmail) {
            this.data.email = savedEmail;
            await this.service.render();
        }
    }

    public setView(view: AccessView) {
        this.view = view;

        if (view === 'signup' && this.data.email && !this.signupData.email) {
            this.signupData.email = this.data.email;
        }

        if (view === 'recover' && this.data.email && !this.recoverData.email) {
            this.recoverData.email = this.data.email;
        }

        this.renderNow();
    }

    public togglePassword(scope: string) {
        if (scope === 'signup') {
            this.showSignupPassword = !this.showSignupPassword;
            this.renderNow();
            return;
        }

        this.showPassword = !this.showPassword;
        this.renderNow();
    }

    private renderNow() {
        try {
            this.ref.detectChanges();
        } catch (error) { }
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: '',
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login() {
        if (this.busy) return;

        let user = JSON.parse(JSON.stringify(this.data));
        user.email = this.normalizeEmail(user.email);

        if (!user.email) {
            await this.alert('이메일을 입력해주세요.');
            return;
        }
        if (!this.isEmail(user.email)) {
            await this.alert('이메일 형식을 확인해주세요.');
            return;
        }
        if (!user.password) {
            await this.alert('비밀번호를 입력해주세요.');
            return;
        }

        this.busy = true;
        await this.service.render();
        try {
            let response: any = await wiz.call('login', user);
            let { code, data } = response;

            if (code == 200) {
                this.saveEmailPreference(user.email);
                location.href = '/dashboard';
                return;
            }

            await this.alert((data && data.message) || '로그인에 실패했습니다.', 'error');
        } catch (error) {
            await this.alert('로그인 처리 중 문제가 발생했습니다.', 'error');
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    public async register() {
        if (this.busy) return;

        let request = JSON.parse(JSON.stringify(this.signupData));
        request.name = (request.name || '').trim();
        request.email = this.normalizeEmail(request.email);
        request.mobile = (request.mobile || '').trim();

        if (!request.name) {
            await this.alert('이름을 입력해주세요.');
            return;
        }
        if (!request.email) {
            await this.alert('이메일을 입력해주세요.');
            return;
        }
        if (!this.isEmail(request.email)) {
            await this.alert('이메일 형식을 확인해주세요.');
            return;
        }
        if (!request.password || request.password.length < 8) {
            await this.alert('비밀번호는 8자 이상 입력해주세요.');
            return;
        }
        if (request.password !== request.passwordConfirm) {
            await this.alert('비밀번호 확인이 일치하지 않습니다.');
            return;
        }
        if (!request.agreement) {
            await this.alert('계정 정보 처리 동의가 필요합니다.');
            return;
        }

        this.busy = true;
        this.renderNow();
        await this.service.render();
        try {
            request.action = 'register';
            let response: any = await wiz.call('login', request, { timeout: 15000 });
            let { code, data } = response;

            if (code == 200) {
                this.busy = false;
                this.data.email = request.email;
                this.data.password = '';
                this.signupData.password = '';
                this.signupData.passwordConfirm = '';
                this.signupData.agreement = false;
                this.setView('login');
                await this.alert('회원가입이 완료되었습니다. 로그인해주세요.', 'success');
                return;
            }

            this.busy = false;
            this.renderNow();
            await this.alert((data && data.message) || '회원가입 처리에 실패했습니다.', 'error');
        } catch (error) {
            this.busy = false;
            this.renderNow();
            await this.alert('회원가입 처리 중 문제가 발생했습니다.', 'error');
        } finally {
            this.busy = false;
            this.renderNow();
        }
    }

    public async requestPasswordHelp() {
        if (this.busy) return;

        let request = JSON.parse(JSON.stringify(this.recoverData));
        request.email = this.normalizeEmail(request.email);
        request.name = (request.name || '').trim();

        if (!request.email) {
            await this.alert('이메일을 입력해주세요.');
            return;
        }
        if (!this.isEmail(request.email)) {
            await this.alert('이메일 형식을 확인해주세요.');
            return;
        }
        if (!request.name) {
            await this.alert('이름을 입력해주세요.');
            return;
        }

        this.busy = true;
        await this.service.render();
        try {
            request.action = 'password_help';
            let response: any = await wiz.call('login', request);
            let { code, data } = response;

            if (code == 200) {
                await this.alert((data && data.message) || '계정 확인이 완료되었습니다.', 'success');
                return;
            }

            await this.alert((data && data.message) || '계정 정보를 확인할 수 없습니다.', 'error');
        } catch (error) {
            await this.alert('계정 확인 중 문제가 발생했습니다.', 'error');
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    private normalizeEmail(email: string) {
        return (email || '').trim().toLowerCase();
    }

    private isEmail(email: string) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || '');
    }

    private getSavedEmail() {
        try {
            return localStorage.getItem('songnisan.access.email') || '';
        } catch (error) {
            return '';
        }
    }

    private saveEmailPreference(email: string) {
        try {
            if (this.rememberEmail) {
                localStorage.setItem('songnisan.access.email', email);
            } else {
                localStorage.removeItem('songnisan.access.email');
            }
        } catch (error) { }
    }
}

export default PageAccessComponent;